import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class Label extends Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    type: PropTypes.oneOf([
      'default',
      'primary',
      'success',
      'info',
      'warning',
      'danger'
    ]).isRequired
  }

  render() {
    const { text, type } = this.props

    return <span className={`label label-${type}`}>{I18n.t(text)}</span>
  }
}



// WEBPACK FOOTER //
// ../src/components/Label.js